import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import { AnimatePresence } from "framer-motion";
import { ProfileModalShell } from "../Profile/ProfileModalShell";
import { useCloseOnHistoryBack } from "../../hooks/useCloseOnHistoryBack";
import { ModalCloseButton } from "../ModalCloseIcon";
import { XpRulesContent } from "./xpRulesContent";
import { XP_BACK_ARROW_CLASS, XP_BACK_ARROW_SRC, XP_LIME_BACK_BUTTON_CLASS } from "./xpModalNav";

type XpAboutModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

export function XpAboutModal({ isOpen, onClose }: XpAboutModalProps) {
  useCloseOnHistoryBack(isOpen, onClose);
  useEffect(() => {
    if (!isOpen) return undefined;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [isOpen, onClose]);

  if (typeof document === "undefined") return null;

  return createPortal(
    <AnimatePresence>
      {isOpen ? (
        <ProfileModalShell
          onClose={onClose}
          zIndexClass="z-[10030]"
          overlayAriaLabel="Close About XP"
        >
          <div className="flex min-h-0 flex-1 flex-col">
            <div className="shrink-0 border-b border-white/10 px-3 py-2 pt-1 sm:pt-1.5">
              <div className="grid shrink-0 grid-cols-[1fr_auto_1fr] items-center gap-x-2">
                <div className="col-start-1 flex min-w-0 items-start justify-self-start">
                  <button type="button" onClick={onClose} className={XP_LIME_BACK_BUTTON_CLASS}>
                    <img src={XP_BACK_ARROW_SRC} alt="" className={XP_BACK_ARROW_CLASS} aria-hidden />
                    XP HISTORY
                  </button>
                </div>
                <div className="col-start-2 flex min-w-0 items-center justify-center justify-self-center gap-1.5 px-1">
                  <img src="/assets/xp.webp" alt="" className="h-5 w-5 shrink-0 object-contain" aria-hidden />
                  <h2
                    id="xp-about-title"
                    className="truncate font-anton text-[20px] font-normal uppercase leading-[26px] tracking-normal text-white [leading-trim:none]"
                  >
                    About XP
                  </h2>
                </div>
                <div className="col-start-3 justify-self-end">
                  <ModalCloseButton
                    onClick={onClose}
                    ariaLabel="Close About XP"
                    className="h-11 w-11 shrink-0 rounded-none hover:bg-white/10 hover:opacity-100"
                  />
                </div>
              </div>
            </div>

            <div
              className="min-h-0 flex-1 overflow-y-auto overscroll-contain px-3 pb-4 pt-3"
              aria-labelledby="xp-about-title"
            >
              <XpRulesContent />
            </div>
          </div>
        </ProfileModalShell>
      ) : null}
    </AnimatePresence>,
    document.body
  );
}
